<label class="step-header">{{ header }}</label>
<p class="preview-text float-right color-467fcf padding-right-24 margin-top-15" *ngIf="header.indexOf('Preview') !== -1" (click)="move(0)">
  <a class="edit">Edit</a></p>
<div class="divider"></div>

